import { render, staticRenderFns } from "./autoUpDetail.vue?vue&type=template&id=33f82b10"
import script from "./autoUpDetail.vue?vue&type=script&lang=js"
export * from "./autoUpDetail.vue?vue&type=script&lang=js"
import style0 from "./autoUpDetail.vue?vue&type=style&index=0&id=33f82b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports